module.exports = __webpack_public_path__ + "static/img/total_en.75ac7eef.png";